import type { ParserProps } from '@/app_lib/htmlParser/types';
import {
  cmsHtmlScriptToReactElement,
  getScriptTextContentFromHtmlElement,
} from '@/app_lib/services/oneTrust/cmsScriptAutoblock';

export const ScriptParser = ({ domNode }: ParserProps) => {
  const scriptContent = getScriptTextContentFromHtmlElement(domNode);
  return cmsHtmlScriptToReactElement(domNode.attribs, scriptContent || undefined);
};
